import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/www')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<I18nProvider i18n={i18n}>
			<Outlet />
		</I18nProvider>
	);
}
